import VueClock from './VueClock.vue';
const Plugin = {}

Plugin.install = function install (Vue) {
    if (install.installed) {
        return;
    }
    install.installed = true;
    Vue.component('VueClock', VueClock);
}

export default Plugin

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin)
}
